export default __webpack_public_path__ + "static/media/01.bb80566c.jpg";